import { combineReducers } from 'redux'

import { createReducer } from 'helpers/ReducerUtil'
import {
  REMOVE_APPROVAL,
  UPDATE_APPROVAL_LIST,
  UPDATE_CURRENT_APPROVAL,
  RESET_CURRENT_APPROVAL,
  CLEAR_APPROVAL_LIST,
  RESET_PRODUCT_CATEGORY_FILTER,
  UPDATE_PRODUCT_CATEGORY_FILTER,
  UPDATE_APPROVAL_COUNT,
} from './constants'

const updateApprovalCount = (current, action) => action.count
const resetCurrentApproval = () => null
const resetProductCategoryFilter = () => 'all'
const clearApprovalList = () => []
const updateCurrentApproval = (current, action) => action.approval
const updateApprovalList = (approvals, action) => action.approvals ? action.approvals : []
const updateProductCategoryFilter = (filter, action) => action.filter
const removeCurrentApproval = (current, action) => action.approval === current
  ? resetCurrentApproval()
  : current
const removeApproval = (approvals, action) => approvals.filter(approval => approval !== action.approval)

const approvalsReducer = createReducer([], {
  [UPDATE_APPROVAL_LIST]: updateApprovalList,
  [CLEAR_APPROVAL_LIST]: clearApprovalList,
  [REMOVE_APPROVAL]: removeApproval,
})

const currentApprovalReducer = createReducer(null, {
  [RESET_CURRENT_APPROVAL]: resetCurrentApproval,
  [UPDATE_CURRENT_APPROVAL]: updateCurrentApproval,
  [REMOVE_APPROVAL]: removeCurrentApproval,
})

const productCategoryFilter = createReducer('all', {
  [RESET_PRODUCT_CATEGORY_FILTER]: resetProductCategoryFilter,
  [UPDATE_PRODUCT_CATEGORY_FILTER]: updateProductCategoryFilter,
})

const approvalCountReducer = createReducer(0, {
  [UPDATE_APPROVAL_COUNT]: updateApprovalCount,
})

export {
  approvalsReducer,
  currentApprovalReducer,
  productCategoryFilter,
  approvalCountReducer,
}
